import { Controller } from '@hotwired/stimulus'

export default class TabsController extends Controller {
  static targets = ['button', 'panel']

  connect() {
    const buttons = this.buttonTargets

    const buttonClasses = Array.from(buttons).map((b) => ({
      class: b.getAttribute('class'),
      disabled: b.getAttribute('disabled') === ''
    }))

    this.activeClassName = buttonClasses.find((obj) => !obj.disabled)?.class
    this.disabledClassName = buttonClasses.find((obj) => obj.disabled)?.class
  }

  click(event) {
    if (this.element.dataset.sparkHydrated === 'true') return

    const button = event.target
    const index = parseInt(button.dataset.tabsIndex)
    const panel = this.panelTargets[index]

    button.setAttribute('disabled', '')

    const display = window.getComputedStyle(panel, null).display

    if (display === 'none') {
      panel.style.display = 'block'
      button.setAttribute('class', button.getAttribute('class')?.replace(this.activeClassName, this.disabledClassName))

      this.buttonTargets.forEach((b, i) => {
        if (i !== index) {
          b.removeAttribute('disabled')
          b.setAttribute('class', b.getAttribute('class')?.replace(this.disabledClassName, this.activeClassName))
        }
      })

      this.panelTargets.forEach((p, i) => {
        if (i !== index) {
          p.style.display = 'none'
        }
      })
    }
  }
}
